//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosGet } from '../../../axios/axios.js'

import BrigadeForkliftTruckFieldTable from './BrigadeForkliftTruckFieldTable.vue'
import VehicleProvisionDispatcher from '../../../forms/VehicleProvision/VehicleProvisionDispatcher.vue'

export default {
  name: 'BrigadeForkliftTruckField',
  components: {
    BrigadeForkliftTruckFieldTable
  },
  props: {
    brigade: {
      type: Object,
      default () {
        return {}
      }
    },
    readonly: {
      type: Boolean,
      default: false
    },
    create: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      forkliftTruckRequests: []
    }
  },
  methods: {
    createVehicleProvisionRequest: function () {
      const vehicleProvisionId = -1
      const additionalParams = {}
      if (this.brigade) {
        additionalParams.brigade = {
          id: this.brigade.id,
          workDate: this.brigade.startWorkTime,
          workShift: this.brigade.workShift.key
        }
      }

      this.$d.dialog(this).show({
        maximized: true,
        persistent: true,
        headerHidden: true,
        contentComponent: VehicleProvisionDispatcher,
        contentProps: {
          vehicleProvisionId: vehicleProvisionId,
          inputAdditionalParams: additionalParams,
          dialog: true
        },
        componentHandlers: {
          cancel: () => {
            this.$emit('updated')
          }
        }
      })
    },
    onShowTable: function () {
      this.$d.dialog(this).show({
        maximized: false,
        class: 'brigade-forklift-truck-table--dialog',
        headerLabel: 'Заявки на предоставление ТС на смену бригады',
        contentComponent: BrigadeForkliftTruckFieldTable,
        contentProps: {
          forkliftTruckRequests: this.forkliftTruckRequests,
          brigade: this.brigade,
          readonly: this.readonly
        },
        componentHandlers: {
          'vehicle-provision-close': () => {
            this.$emit('updated')
            this.getForkliftTrucks()
          }
        }
      })
    },
    onAdd: function () {
      this.getForkliftTrucks().then(() => {
        this.onShowTable()
      })
    },
    getForkliftTrucks: function () {
      this.forkliftTruckRequests.splice(0, this.forkliftTruckRequests.length)

      return axiosGet({
        /*
        ignoreWorkArea: { // не проверять соответствие направлений бригады и заявки
          type: Boolean,
          default: false
        },
        includeWithoutRequest: { // включать в список ТС без заявок на выбраную смену
          type: Boolean,
          default: false
        }
        */
        url: `/service/delta/vehicleProvision/forkliftTrucks?brigadeId=${this.brigade.id}&workDate=${this.brigade.startWorkTime}&workShiftKey=${this.brigade.workShift.key}`,
        onSuccess: (response) => {
          this.forkliftTruckRequests.push(...response.data.result)
        },
        onFailure: 'Ошибка получения доступных для выбора транспортных средств'
      })
    }
  }
}

